import { React } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

export default function NewGuestNameInput(props) {
  const { value, setValue, placeholder, error } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  function handleClick(e) {
  }

  function handleChange(e) {
    setValue(e.target.value);
  }

  function handleFocus(e) {
  }

  function handleBlur(e) {
  }

  return (
    <InputWrapper>
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        $placeholderColor={error ? theme.pointRed : undefined}
        onClick={handleClick}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
    </InputWrapper>
  )
};

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 7px 12px 7px 12px;

  width: 100%;
  box-sizing: border-box;

  border: 1px solid ${props => props.theme.line};
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};
`;

const Input = styled.input`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  width: 100%;
  height: 100%;

	outline: none;
  border: 0px;
  
	color: ${props => props.theme.text};
  background-color: transparent;

	&::placeholder {
    font-family: NotoSansKR-Medium;
    font-size: 14px;

    color: ${props => props.$placeholderColor || props.theme.line};

    transition: color 0.3s ease-in-out;
	}
	
  transition: all 0.3s ease-in-out;
`;